import {TranslateSvc} from '../../services/TranslateSvc';

class TitleBlock implements ng.IComponentController {
    level: number;
    tbTitle: string;
    description: string;
    color: 'white' | 'gray' | 'black';
    size: 'small' | 'medium' | 'prelarge' | 'large';

    constructor(private $sce: ng.ISCEService,
                private TranslateSvc: TranslateSvc,
                private $scope: ng.IScope,
                private $element: ng.IAugmentedJQuery,
                private $compile: ng.ICompileService) {
        this.level = this.level || 2;
        const mapText = _.compose(this.getHtml, this.translate);
        this.tbTitle = mapText(this.tbTitle);
        this.description = mapText(this.description);
        this.appendH1();
    }

    private appendH1() {
        const h1 = angular.element(`<h${this.level} ng-bind-html="$ctrl.tbTitle" class="title-block-title"></h>`);
        const container = this.$element[0].querySelector('.title-block');
        const compiledH1 = this.$compile(h1)(this.$scope);

        angular.element(container).prepend(compiledH1);
    }

    private getHtml = (html: string) => {
        return this.$sce.trustAsHtml(html);
    }

    private translate = (str: string) => {
        return this.TranslateSvc.has(str) ? this.TranslateSvc.get(str) : str;
    }
}

angular.module('animatronApp.titleBlock', []).component('titleBlock', {
    bindings: {
        level: '<',
        tbTitle: '<',
        description: '<',
        color: '@',
        size: '@'
    },
    controller: TitleBlock,
    templateUrl: require('landing-template/components/title-block.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/TitleBlock.ts